<div [class.is-invalid]="showError">
  <ng-container #fieldComponent />
</div>
